import { UserConnection, UserConnectionActionType, UserConnectionListKey } from '@alltrails/shared/types/belay';

// UserConnections can have multiple action types, but depending on the context of the user connection, different actions will be visible
const defaultFollowActionPriorities = [
  UserConnectionActionType.FollowBack,
  UserConnectionActionType.Follow,
  UserConnectionActionType.RetractRequest,
  UserConnectionActionType.Unfollow
];
const connectActionPriorities: Record<UserConnectionListKey, UserConnectionActionType[]> = {
  [UserConnectionListKey.FindFriends]: defaultFollowActionPriorities,
  [UserConnectionListKey.FollowerRequests]: [UserConnectionActionType.Accept, ...defaultFollowActionPriorities],
  [UserConnectionListKey.Suggested]: defaultFollowActionPriorities,
  [UserConnectionListKey.Reactors]: defaultFollowActionPriorities,
  [UserConnectionListKey.Blocked]: [UserConnectionActionType.Unblock, ...defaultFollowActionPriorities, UserConnectionActionType.Block],
  [UserConnectionListKey.Following]: defaultFollowActionPriorities,
  [UserConnectionListKey.Followers]: defaultFollowActionPriorities,
  [UserConnectionListKey.Mutual]: defaultFollowActionPriorities,
  [UserConnectionListKey.TrailReview]: defaultFollowActionPriorities,
  [UserConnectionListKey.Notifications]: [UserConnectionActionType.Accept, ...defaultFollowActionPriorities],
  [UserConnectionListKey.Feed]: defaultFollowActionPriorities,
  [UserConnectionListKey.Collaborators]: defaultFollowActionPriorities
};

export const getConnectActionType = (userConnection: UserConnection, listKey?: UserConnectionListKey) => {
  const actionsTypes = Object.keys(userConnection.actions) as UserConnectionActionType[];

  const actions = listKey ? connectActionPriorities[listKey] : defaultFollowActionPriorities;
  return actions.find(action => actionsTypes.includes(action));
};

export const getButtonStyle = (actionType: UserConnectionActionType) => {
  if (actionType === UserConnectionActionType.RetractRequest || actionType === UserConnectionActionType.Unfollow) {
    return 'default';
  }
  if (actionType === UserConnectionActionType.Block || actionType === UserConnectionActionType.Unblock) {
    return 'destructive';
  }
  return 'primary';
};
